import { categoryMockData } from '@/mock/category';
import { brandMockData } from '@/mock/brand';
import * as orderMockData from '@/mock/order';
import * as menuMockData from '@/mock/menu';
import * as productMockData from '@/mock/product';
import * as stockAllocationMockData from '@/mock/stockAllocation';
import dayjs from 'dayjs';


interface ApiResponse<T = any> {
  success: boolean;
  code: number;
  data: T;
  message: string;
}

const delay = (ms: number = 300) => new Promise(resolve => setTimeout(resolve, ms));

// Mock 验证码图片（base64编码的简单图片）
const mockCaptchaImage = 'data:image/png;base64,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';

export async function mockHandler<T>(method: 'get' | 'post' | 'put' | 'delete' | 'patch', url: string, data?: any, config?: any): Promise<ApiResponse<T>> {
  await delay();

  // 认证相关 mock
  if (method === 'get' && url === '/captcha') {
    // 生成随机验证码 (4位数字)
    const captchaText = Math.floor(1000 + Math.random() * 9000).toString();
    
    // 为测试环境保存验证码文本到localStorage，实际环境中不应该这样做
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('lastCaptchaText', captchaText);
        localStorage.setItem('lastCaptchaIdKey', `captcha_${Date.now()}`);
      } catch (e) {
        console.warn('Failed to save captcha to localStorage', e);
      }
    }
    
    return {
      success: true,
      code: 200,
      data: {
        base64: mockCaptchaImage,
        text: captchaText, // 在实际应用中应该不返回验证码文本，但在mock环境中返回方便测试
        id_key: `captcha_${Date.now()}`
      } as any as T,
      message: '获取验证码成功'
    };
  }
  
  if (method === 'post' && url === '/login') {
    // 验证用户名、密码和验证码
    const { username, password, captcha, id_key } = data;
    
  
    
    // 验证用户名和密码
    if (username === 'admin' && password === 'admin') {
      return {
        success: true,
        code: 200,
        data: {
          token: `mock_token_${Date.now()}`,
          user: {
            id: 1,
            username: 'admin',
            nickname: '管理员',
            avatar: 'https://joeschmoe.io/api/v1/random',
            permissions: ['*']
          }
        } as any as T,
        message: '登录成功'
      };
    } else {
      return {
        success: false,
        code: 401,
        data: null as any as T,
        message: '用户名或密码错误'
      };
    }
  }

  if (method === 'get' && url === '/logout') {
    return {
      success: true,
      code: 200,
      data: null as any as T,
      message: '登出成功'
    };
  }

  if (method === 'get' && url === '/user/self/info') {
    return {
      success: true,
      code: 200,
      data: {
        id: 1,
        username: 'admin',
        nickname: '系统管理员',
        avatar: 'https://joeschmoe.io/api/v1/random',
        email: 'admin@example.com',
        phone: '13800138000',
        gender: 1,
        status: 1,
        roles: [
          { id: 1, name: '管理员', code: 'admin', status: 1 }
        ],
        permissions: [
          { id: 1, name: '全部权限', code: '*', type: 1, status: 1 }
        ]
      } as any as T,
      message: '获取用户信息成功'
    };
  }

  // 分类相关
  if (url.startsWith('/categories')) {
    if (method === 'get') {
      if (url === '/categories/options') {
        return { success: true, code: 200, data: categoryMockData.getCategoryOptions() as T, message: '获取成功' };
      }
      if (url === '/categories/tree') {
        return { success: true, code: 200, data: categoryMockData.getCategoryTree() as T, message: '获取成功' };
      }
      if (url === '/categories') {
        return { success: true, code: 200, data: categoryMockData.getCategoryList(config?.params) as T, message: '获取成功' };
      }
      if (url.startsWith('/categories/')) {
        const id = url.split('/categories/')[1];
        return { success: true, code: 200, data: categoryMockData.getCategoryDetail(id) as T, message: '获取成功' };
      }
    }
    if (method === 'post' && url === '/categories') {
      return { success: true, code: 200, data: categoryMockData.createCategory(data) as T, message: '创建成功' };
    }
    if (method === 'put' && url.startsWith('/categories/')) {
      const id = url.split('/categories/')[1];
      return { success: true, code: 200, data: categoryMockData.updateCategory(id, data) as T, message: '更新成功' };
    }
    if (method === 'delete' && url.startsWith('/categories/')) {
      const id = url.split('/categories/')[1];
      return { success: true, code: 200, data: categoryMockData.deleteCategory(id) as T, message: '删除成功' };
    }
  }
  // 品牌相关
  if (url.startsWith('/brands')) {
    if (method === 'get') {
      if (url === '/brands/options') {
        return { success: true, code: 200, data: brandMockData.getBrandOptions() as any as T, message: '获取成功' };
      }
      if (url === '/brands') {
        return { success: true, code: 200, data: brandMockData.getBrandList(config?.params) as any as T, message: '获取成功' };
      }
      if (url.startsWith('/brands/')) {
        const id = url.split('/brands/')[1];
        return { success: true, code: 200, data: brandMockData.getBrandDetail(id) as any as T, message: '获取成功' };
      }
    }
    if (method === 'post' && url === '/brands') {
      return { success: true, code: 200, data: brandMockData.createBrand(data) as any as T, message: '创建成功' };
    }
    if (method === 'put' && url.startsWith('/brands/')) {
      const id = url.split('/brands/')[1];
      return { success: true, code: 200, data: brandMockData.updateBrand(id, data) as any as T, message: '更新成功' };
    }
    if (method === 'delete' && url.startsWith('/brands/')) {
      const id = url.split('/brands/')[1];
      return { success: true, code: 200, data: brandMockData.deleteBrand(id) as any as T, message: '删除成功' };
    }
  }
  // 订单相关
  if (url.startsWith('/oms/sales-order')) {
    if (method === 'get') {
      if (url === '/oms/sales-order') {
        const params = config?.params || {};
        const { data, total } = orderMockData.querySalesOrders(params);
        return { 
          success: true, 
          code: 200, 
          data: {
            list: data,
            total
          } as any as T, 
          message: '获取成功'
        };
      }
      if (url === '/oms/sales-order/statistics' || (url.startsWith('/oms/sales-order/') && url.endsWith('/statistics'))) {
        return { 
          success: true, 
          code: 200, 
          data: orderMockData.getSalesOrderStats() as any as T, 
          message: '获取成功'
        };
      }
      if (url === '/oms/sales-order/options') {
        return { 
          success: true, 
          code: 200, 
          data: {
            warehouses: [],
            distributors: [],
            deliveries: [],
            paymentMethods: [],
            invoiceTypes: []
          } as any as T, 
          message: '获取成功'
        };
      }
      if (url.startsWith('/oms/sales-order/') && !url.includes('/statistics')) {
        const id = url.split('/oms/sales-order/')[1];
        const order = orderMockData.salesOrderMockData.find((item: orderMockData.SalesOrder) => item.id === id);
        if (order) {
          return { success: true, code: 200, data: order as any as T, message: '获取成功' };
        } else {
          return { success: false, code: 404, data: null as any as T, message: '订单不存在' };
        }
      }
    }
    if (method === 'post') {
      if (url === '/oms/sales-order') {
        const newOrder = {
          id: `order-${Date.now()}`,
          orderNo: `SO-${dayjs().format('YYYYMMDD')}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          ...data
        };
        return { success: true, code: 200, data: newOrder as any as T, message: '创建成功' };
      }
      if (url.includes('/submit')) {
        const id = url.split('/oms/sales-order/')[1].split('/submit')[0];
        return { success: true, code: 200, data: { id, status: 'submitted' } as any as T, message: '提交成功' };
      }
      if (url.includes('/audit')) {
        const id = url.split('/oms/sales-order/')[1].split('/audit')[0];
        return { success: true, code: 200, data: { id, action: data.action } as any as T, message: '审核成功' };
      }
      if (url.includes('/confirm')) {
        const id = url.split('/oms/sales-order/')[1].split('/confirm')[0];
        return { success: true, code: 200, data: { id, status: 'confirmed' } as any as T, message: '确认成功' };
      }
      if (url.includes('/cancel')) {
        const id = url.split('/oms/sales-order/')[1].split('/cancel')[0];
        return { success: true, code: 200, data: { id, status: 'cancelled', reason: data.reason } as any as T, message: '取消成功' };
      }
      if (url.includes('/ship')) {
        const id = url.split('/oms/sales-order/')[1].split('/ship')[0];
        return { success: true, code: 200, data: { id, status: 'shipped', ...data } as any as T, message: '发货成功' };
      }
      if (url.includes('/receive')) {
        const id = url.split('/oms/sales-order/')[1].split('/receive')[0];
        return { success: true, code: 200, data: { id, status: 'received' } as any as T, message: '收货成功' };
      }
      if (url.includes('/batch/delete')) {
        return { success: true, code: 200, data: { ids: data.ids } as any as T, message: '批量删除成功' };
      }
      if (url.includes('/batch/export')) {
        return { success: true, code: 200, data: { ids: data.ids } as any as T, message: '批量导出成功' };
      }
      if (url.includes('/batch/status')) {
        return { 
          success: true, 
          code: 200, 
          data: { 
            ids: data.ids, 
            status: data.status,
            remark: data.remark
          } as any as T, 
          message: '批量更新状态成功' 
        };
      }
    }
    if (method === 'put' && url.startsWith('/oms/sales-order/')) {
      const id = url.split('/oms/sales-order/')[1];
      const order = orderMockData.salesOrderMockData.find((item: orderMockData.SalesOrder) => item.id === id);
      
      if (order) {
        const updatedOrder = {
          ...order,
          ...data,
          updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss')
        };
        
        return { success: true, code: 200, data: updatedOrder as any as T, message: '更新成功' };
      } else {
        return { success: false, code: 404, data: null as any as T, message: '订单不存在' };
      }
    }
    if (method === 'delete' && url.startsWith('/oms/sales-order/')) {
      const id = url.split('/oms/sales-order/')[1];
      return { success: true, code: 200, data: { id, deleted: true } as any as T, message: '删除成功' };
    }
  }

    // 销售订单API
  if (method === 'get' && url === '/oms/sales-order') {
    const params = config?.params || {};
    const { data, total } = orderMockData.querySalesOrders(params);
    return {
      success: true,
      code: 200,
      data: {
        list: data,
        total
      } as any as T,
      message: '获取销售订单列表成功'
    };
  }

  if (method === 'get' && url === '/oms/sales-order/statistics') {
    const stats = orderMockData.getSalesOrderStats();
    return {
      success: true,
      code: 200,
      data: stats as any as T,
      message: '获取销售订单统计成功'
    };
  }

  if (method === 'get' && url.startsWith('/oms/sales-order/') && url !== '/oms/sales-order/statistics') {
    const id = url.split('/').pop();
    const order = orderMockData.salesOrderMockData.find((item: orderMockData.SalesOrder) => item.id === id);
    
    if (order) {
      return {
        success: true,
        code: 200,
        data: order as any as T,
        message: '获取销售订单详情成功'
      };
    } else {
      return {
        success: false,
        code: 404,
        data: null as any as T,
        message: '订单不存在'
      };
    }
  }

  if (method === 'post' && url === '/oms/sales-order') {
    const newOrder = {
      id: `order-${Date.now()}`,
      orderNo: `SO-${dayjs().format('YYYYMMDD')}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      ...data
    };
    
    return {
      success: true,
      code: 200,
      data: newOrder as any as T,
      message: '创建销售订单成功'
    };
  }

  if (method === 'put' && url.startsWith('/oms/sales-order/')) {
    const id = url.split('/').pop();
    const order = orderMockData.salesOrderMockData.find((item: orderMockData.SalesOrder) => item.id === id);
    
    if (order) {
      const updatedOrder = {
        ...order,
        ...data,
        updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss')
      };
      
      return {
        success: true,
        code: 200,
        data: updatedOrder as any as T,
        message: '更新销售订单成功'
      };
    } else {
      return {
        success: false,
        code: 404,
        data: null as any as T,
        message: '订单不存在'
      };
    }
  }

  if (method === 'delete' && url.startsWith('/oms/sales-order/')) {
    return {
      success: true,
      code: 200,
      data: null as any as T,
      message: '删除销售订单成功'
    };
  }
  
  // 菜单相关 mock
  if (method === 'get' && url === '/menu') {
    // 处理菜单列表查询
    const params = config?.params;
    const result = menuMockData.getMenuList(params);
    return {
      success: true,
      code: 200,
      message: 'OK',
      data: result as unknown as T
    };
  }
  
  if (method === 'get' && url === '/menu/tree') {
    // 处理菜单树查询
    const params = config?.params;
    const result = menuMockData.getMenuTree(params);
    return {
      success: true,
      code: 200,
      message: 'OK',
      data: result.data as unknown as T
    };
  }
  
  if (method === 'get' && url.startsWith('/menu/') && url !== '/menu/user' && url !== '/menu/tree') {
    // 处理菜单详情查询
    const id = url.split('/menu/')[1];
    const result = menuMockData.getMenuDetail(id);
    return {
      success: result.success,
      code: result.success ? 200 : 404,
      message: result.success ? 'OK' : '菜单不存在',
      data: result.data as unknown as T
    };
  }
  
  if (method === 'post' && url === '/menu') {
    // 处理创建菜单
    const result = menuMockData.createMenu(data);
    return {
      success: true,
      code: 200,
      message: '创建菜单成功',
      data: result.data as unknown as T
    };
  }
  
  if (method === 'put' && url.startsWith('/menu/')) {
    // 处理更新菜单
    const id = url.split('/menu/')[1];
    const result = menuMockData.updateMenu(id, data);
    return {
      success: result.success,
      code: result.success ? 200 : 404,
      message: result.success ? '更新菜单成功' : '菜单不存在',
      data: result.data as unknown as T
    };
  }
  
  if (method === 'delete' && url.startsWith('/menu/')) {
    // 处理删除菜单
    const id = url.split('/menu/')[1];
    const result = menuMockData.deleteMenu(id);
    return {
      success: result.success,
      code: 200,
      message: '删除菜单成功',
      data: null as unknown as T
    };
  }
  
  if (method === 'get' && (url === '/menu/user' || url === '/api/v1/menu/user')) {
    return {
      success: true,
      code: 200,
      message: 'OK',
      data: menuMockData.getMenuUser() as any as T
    };
  }
  // 登录相关 mock
  if (method === 'post' && url === '/login') {
    return {
      success: true,
      code: 200,
      data: {
        token: 'mock-token',
        user: {
          id: '1',
          name: 'admin',
          avatar: 'https://img.example.com/avatar.png',
          roles: ['admin'],
        },
      } as any as T,
      message: '登录成功',
    };
  }
  if (method === 'post' && url === '/login/code') {
    return {
      success: true,
      code: 200,
      data: {
        token: `mock_token_${Date.now()}`,
        user: {
          id: '1',
          name: 'admin',
          avatar: 'https://joeschmoe.io/api/v1/random',
          roles: ['admin'],
        },
      } as any as T,
      message: '登录成功',
    };
  }
  // 用户信息 mock
  if (method === 'get' && (url === '/auth/user' || url === '/user/self/info')) {
    return {
      success: true,
      code: 200,
      data: {
        id: '1',
        name: 'admin',
        avatar: 'https://img.example.com/avatar.png',
        email: 'admin@example.com',
        phone: '13800000000',
        roles: ['admin'],
      } as any as T,
      message: '获取成功',
    };
  }
  // 登出 mock
  if (method === 'post' && url === '/auth/logout') {
    return {
      success: true,
      code: 200,
      data: null as unknown as T,
      message: '登出成功',
    };
  }
  // 通用 mock（去掉 /api/v1 前缀）
  const urlV1 = url.startsWith('/api/v1/') ? url.replace('/api/v1', '') : url;
  // 登录相关
  if (method === 'post' && urlV1 === '/login/code') {
    return {
      success: true,
      code: 200,
      data: {
        token: 'mock-token',
        user: {
          id: '1',
          name: 'admin',
          avatar: 'https://img.example.com/avatar.png',
          roles: ['admin'],
        },
      } as any as T,
      message: '登录成功',
    };
  }
  if (method === 'post' && urlV1 === '/forget/password') {
    return {
      success: true,
      code: 200,
      data: null as unknown as T,
      message: '重置密码邮件已发送',
    };
  }
  if (method === 'get' && urlV1 === '/captcha') {
    // 使用与主端点相同的逻辑处理V1 API版本
    // 生成随机验证码 (4位数字)
    const captchaText = Math.floor(1000 + Math.random() * 9000).toString();
    const id_key = `captcha_${Date.now()}`;
    
    // 为测试环境保存验证码文本到localStorage
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem('lastCaptchaText', captchaText);
        localStorage.setItem('lastCaptchaIdKey', id_key);
      } catch (e) {
        console.warn('Failed to save captcha to localStorage', e);
      }
    }
    
    return {
      success: true,
      code: 200,
      data: {
        base64: mockCaptchaImage,
        text: captchaText,
        id_key: id_key
      } as any as T,
      message: '获取成功',
    };
  }
  if (method === 'post' && urlV1 === '/optcode') {
    return {
      success: true,
      code: 200,
      data: null as unknown as T,
      message: '操作成功',
    };
  }
  if (method === 'post' && urlV1 === '/upload/image') {
    return {
      success: true,
      code: 200,
      data: {
        url: 'https://img.example.com/uploaded-image.png',
      } as any as T,
      message: '上传成功',
    };
  }
  if (method === 'post' && urlV1 === '/upload/file') {
    return {
      success: true,
      code: 200,
      data: {
        url: 'https://img.example.com/uploaded-file.pdf',
      } as any as T,
      message: '上传成功',
    };
  }
  if (method === 'get' && urlV1 === '/pbc/barcode') {
    return {
      success: true,
      code: 200,
      data: {
        barcode: '123456789012',
      } as any as T,
      message: '获取成功',
    };
  }
  if (method === 'post' && urlV1 === '/sms') {
    return {
      success: true,
      code: 200,
      data: null as unknown as T,
      message: '短信发送成功',
    };
  }
  if (method === 'get' && urlV1 === '/sms') {
    return {
      success: true,
      code: 200,
      data: [
        { id: 1, phone: '13800000001', content: '测试短信 1', status: '成功' },
        { id: 2, phone: '13800000002', content: '测试短信 2', status: '失败' },
      ] as any as T,
      message: '获取成功',
    };
  }
  // 角色相关
  if (urlV1.startsWith('/role')) {
    if (method === 'get') {
      if (urlV1 === '/role/options') {
        return { success: true, code: 200, data: [] as any as T, message: '获取成功' };
      }
      if (urlV1 === '/role') {
        return { success: true, code: 200, data: [] as any as T, message: '获取成功' };
      }
      if (urlV1.startsWith('/role/')) {
        const id = urlV1.split('/role/')[1];
        return { success: true, code: 200, data: null as unknown as T, message: '获取成功' };
      }
    }
    if (method === 'post' && urlV1 === '/role') {
      return { success: true, code: 200, data: null as unknown as T, message: '创建成功' };
    }
    if (method === 'put' && urlV1.startsWith('/role/')) {
      const id = urlV1.split('/role/')[1];
      return { success: true, code: 200, data: null as unknown as T, message: '更新成功' };
    }
    if (method === 'delete' && urlV1.startsWith('/role/')) {
      const id = urlV1.split('/role/')[1];
      return { success: true, code: 200, data: null as unknown as T, message: '删除成功' };
    }
  }
  // 用户相关
  if (urlV1.startsWith('/user')) {
    if (method === 'get') {
      if (urlV1 === '/user/options') {
        return { success: true, code: 200, data: [] as any as T, message: '获取成功' };
      }
      if (urlV1 === '/user') {
        return { success: true, code: 200, data: [] as any as T, message: '获取成功' };
      }
      if (urlV1.startsWith('/user/')) {
        const id = urlV1.split('/user/')[1];
        return { success: true, code: 200, data: null as unknown as T, message: '获取成功' };
      }
    }
    if (method === 'post' && urlV1 === '/user') {
      return { success: true, code: 200, data: null as unknown as T, message: '创建成功' };
    }
    if (method === 'put' && urlV1.startsWith('/user/')) {
      const id = urlV1.split('/user/')[1];
      return { success: true, code: 200, data: null as unknown as T, message: '更新成功' };
    }
    if (method === 'delete' && urlV1.startsWith('/user/')) {
      const id = urlV1.split('/user/')[1];
      return { success: true, code: 200, data: null as unknown as T, message: '删除成功' };
    }
  }
  // 库存分配相关 API
  if (url.startsWith('/inventory/allocations')) {
    // 获取库存分配列表
    if (method === 'get' && url === '/inventory/allocations') {
      const page = config?.params?.page || 1;
      const pageSize = config?.params?.pageSize || 10;
      const filters = {
        name: config?.params?.name,
        customerName: config?.params?.customerName,
        status: config?.params?.status,
        effectiveDate: config?.params?.effectiveDate,
        expiryDate: config?.params?.expiryDate
      };
      
      return stockAllocationMockData.generateAllocationList(page, pageSize, filters)
        .then(result => ({
          success: true,
          code: 200,
          data: {
            data: result.data,
            count: result.count,
            page,
            pageSize
          } as any as T,
          message: '获取库存分配列表成功'
        }));
    }
    
    // 获取库存分配详情
    if (method === 'get' && url.startsWith('/inventory/allocations/') && url.includes('/history')) {
      const id = url.split('/inventory/allocations/')[1].split('/history')[0];
      return stockAllocationMockData.getAllocationHistory(id)
        .then(result => ({
          success: true,
          code: 200,
          data: result.data as any as T,
          message: '获取历史记录成功'
        }));
    }
    
    // 获取库存分配详情
    if (method === 'get' && url.startsWith('/inventory/allocations/') && !url.includes('/history') && !url.includes('/check')) {
      const id = url.split('/inventory/allocations/')[1];
      return stockAllocationMockData.getAllocationDetail(id)
        .then(result => {
          if (result.data) {
            return {
              success: true,
              code: 200,
              data: result.data as any as T,
              message: '获取库存分配详情成功'
            };
          } else {
            return {
              success: false,
              code: 404,
              data: null as any as T,
              message: '库存分配不存在'
            };
          }
        });
    }
    
    // 创建库存分配
    if (method === 'post' && url === '/inventory/allocations') {
      const newAllocation = {
        id: `alloc-${String(Math.floor(Math.random() * 900000) + 100000)}`,
        createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        createdBy: '系统管理员',
        updatedBy: '系统管理员',
        ...data
      };
      
      return {
        success: true,
        code: 200,
        data: newAllocation as any as T,
        message: '创建库存分配成功'
      };
    }
    
    // 检查库存分配可行性
    if (method === 'post' && url === '/inventory/allocations/check') {
      const isFeasible = Math.random() > 0.1; // 90%的概率是可行的
      
      return {
        success: true,
        code: 200,
        data: {
          feasible: isFeasible,
          issues: isFeasible ? [] : [
            { 
              productId: data.items?.[0]?.productId || 'unknown', 
              message: '当前商品库存不足，无法完成分配' 
            }
          ]
        } as any as T,
        message: isFeasible ? '分配方案可行' : '分配方案存在问题'
      };
    }
    
    // 批量删除库存分配
    if (method === 'post' && url === '/inventory/allocations/batch/delete') {
      const ids = data?.ids || [];
      
      return {
        success: true,
        code: 200,
        data: { deletedCount: ids.length } as any as T,
        message: `成功删除 ${ids.length} 个库存分配`
      };
    }
    
    // 更新库存分配
    if (method === 'put' && url.startsWith('/inventory/allocations/') && !url.includes('/status')) {
      const id = url.split('/inventory/allocations/')[1];
      
      return {
        success: true,
        code: 200,
        data: {
          ...data,
          id,
          updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          updatedBy: '系统管理员'
        } as any as T,
        message: '更新库存分配成功'
      };
    }
    
    // 更新库存分配状态
    if (method === 'put' && url.includes('/status')) {
      const id = url.split('/inventory/allocations/')[1].split('/status')[0];
      
      return {
        success: true,
        code: 200,
        data: {
          id,
          status: data.status,
          updatedAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          updatedBy: '系统管理员'
        } as any as T,
        message: '更新库存分配状态成功'
      };
    }
    
    // 删除库存分配
    if (method === 'delete' && url.startsWith('/inventory/allocations/')) {
      const id = url.split('/inventory/allocations/')[1];
      
      return {
        success: true,
        code: 200,
        data: { id } as any as T,
        message: '删除库存分配成功'
      };
    }
  }
  
  // 获取可分配的下级客户列表
  if (method === 'get' && url === '/inventory/customers/sub') {
    return stockAllocationMockData.getSubCustomers()
      .then(result => ({
        success: true,
        code: 200,
        data: result.data as any as T,
        message: '获取下级客户成功'
      }));
  }
  
  // 获取可分配的商品列表
  if (method === 'get' && url === '/inventory/products/allocatable') {
    return stockAllocationMockData.getAllocatableProducts()
      .then(result => ({
        success: true,
        code: 200,
        data: result.data as any as T,
        message: '获取可分配商品成功'
      }));
  }
  
  // 获取可分配的仓库列表
  if (method === 'get' && url === '/inventory/warehouses/allocatable') {
    return stockAllocationMockData.getWarehouses()
      .then(result => ({
        success: true,
        code: 200,
        data: result.data as any as T,
        message: '获取可分配仓库成功'
      }));
  }

  // 商品相关 API
  if (url.startsWith('/pms/spu')) {
    if (method === 'get') {
      // 获取商品列表
      if (url === '/pms/spu') {
        const page = config?.params?.page || 1;
        const pageSize = config?.params?.pageSize || 10;
        const filters = {
          name: config?.params?.name,
          category: config?.params?.category,
          brand: config?.params?.brand,
          status: config?.params?.status
        };
        
        return productMockData.generateProductList(page, pageSize, filters)
          .then(result => ({
            success: true,
            code: 200,
            data: result.data,
            total: result.total,
            message: '获取商品列表成功'
          } as any));
      }

      // 获取商品分类
      if (url === '/pms/spu/categories') {
        return productMockData.getProductCategories()
          .then(result => ({
            success: true,
            code: 200,
            data: result.data as any as T,
            message: '获取商品分类成功'
          }));
      }

      // 获取商品品牌
      if (url === '/pms/spu/brands') {
        return productMockData.getProductBrands()
          .then(result => ({
            success: true,
            code: 200,
            data: result.data as any as T,
            message: '获取商品品牌成功'
          }));
      }

      // 获取商品详情
      if (url.startsWith('/pms/spu/') && url !== '/pms/spu/categories' && url !== '/pms/spu/brands') {
        const id = url.split('/pms/spu/')[1];
        return productMockData.getProductDetail(id)
          .then(result => {
            if (result.data) {
              return {
                success: true,
                code: 200,
                data: result.data as any as T,
                message: '获取商品详情成功'
              };
            } else {
              return {
                success: false,
                code: 404,
                data: null as any as T,
                message: '商品不存在'
              };
            }
          });
      }
    }

    // 创建商品
    if (method === 'post' && url === '/pms/spu') {
      const newProduct = {
        id: `lining-${String(Math.floor(Math.random() * 900000) + 100000)}`,
        createTime: new Date().toISOString(),
        updateTime: new Date().toISOString(),
        ...data
      };
      
      return {
        success: true,
        code: 200,
        data: newProduct as any as T,
        message: '创建商品成功'
      };
    }

    // 更新商品
    if (method === 'put' && url.startsWith('/pms/spu/')) {
      const id = url.split('/pms/spu/')[1];
      return productMockData.getProductDetail(id)
        .then(result => {
          if (result.data) {
            const updatedProduct = {
              ...result.data,
              ...data,
              updateTime: new Date().toISOString()
            };
            
            return {
              success: true,
              code: 200,
              data: updatedProduct as any as T,
              message: '更新商品成功'
            };
          } else {
            return {
              success: false,
              code: 404,
              data: null as any as T,
              message: '商品不存在'
            };
          }
        });
    }

    // 删除商品
    if (method === 'delete' && url.startsWith('/pms/spu/')) {
      const id = url.split('/pms/spu/')[1];
      
      return {
        success: true,
        code: 200,
        data: { id } as any as T,
        message: '删除商品成功'
      };
    }

    // 批量删除商品
    if (method === 'post' && url === '/pms/spu/batch/delete') {
      const ids = data?.ids || [];
      
      return {
        success: true,
        code: 200,
        data: { deletedCount: ids.length } as any as T,
        message: `成功删除 ${ids.length} 个商品`
      };
    }
  }

  // 通用 GET 列表
  if (method === 'get' && /\/.+/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 列表', data: [] as any as T };
  }
  // 通用 GET 详情
  if (method === 'get' && /\/.+\/.+/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 详情', data: {} as any as T };
  }
  // 通用 POST 创建
  if (method === 'post' && /\/.+/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 创建成功', data: { id: Date.now(), ...data } as any as T };
  }
  // 通用 PUT 更新
  if (method === 'put' && /\/.+/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 更新成功', data: { ...data } as any as T };
  }
  // 通用 DELETE 删除
  if (method === 'delete' && /\/.+/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 删除成功', data: null as unknown as T };
  }
  // 通用 PATCH 状态
  if (method === 'patch' && /\/.+\/status$/.test(urlV1)) {
    return { success: true, code: 200, message: 'MOCK: 状态变更成功', data: null as unknown as T };
  }
  // 默认响应
  return { success: true, code: 200, data: null as unknown as T, message: 'MOCK: 未匹配到数据' };
}
